import React from 'react';
import useTheme from 'branding/theme';
const ProgressBar = ({ percent, width = 20, height = 100, strokeWidth = 1, ...rest }) => {
    const { colors } = useTheme();
    const rectProps = {
        width: width - strokeWidth * 2,
        x: strokeWidth,
        rx: 2,
        strokeWidth,
        stroke: colors.neutrals.background
    };
    return (React.createElement("svg", { width: width, height: height, ...rest },
        React.createElement("rect", { ...rectProps, height: 
            // strokeWidth hack here allows for perfect stroke in all %
            height - (height * percent) / 100 - (percent === 0 ? strokeWidth * 2 : 0), y: strokeWidth, fill: colors.status.fail.alpha }),
        React.createElement("rect", { ...rectProps, height: (height * percent) / 100 - strokeWidth * 2, y: height - (height * percent) / 100 + strokeWidth, fill: colors.status.success.alpha })));
};
export default ProgressBar;
//# sourceMappingURL=index.js.map